/**
 * Authentication token management utilities
 * Centralized functions for token storage and retrieval
 */

const TOKEN_KEY = 'ACCESS_TOKEN';

/**
 * Get the current access token from localStorage or sessionStorage
 */
export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
};

/**
 * Set the access token in localStorage
 */
export const setToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

/**
 * Clear the access token from localStorage
 */
export const clearToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};

/**
 * Check if a token exists
 */
export const hasToken = (): boolean => {
  return getToken() !== null;
};